import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const apiClient = axios.create({
    baseURL: API,
    headers: { "Content-Type": "application/json" },
});

export async function submitStrategyCall(payload) {
    const { data } = await apiClient.post("/strategy-call", payload);
    return data;
}

export async function submitHireRequest(payload) {
    const { data } = await apiClient.post("/hire-request", payload);
    return data;
}
